'use client';
import React, { useEffect, useState } from 'react';
import { Home } from '@bufdir/statistics-pages-components';
import { toHomeProps } from '../utils';

type Props = {
  data: any;
};

const PageHome: React.FC<Props> = ({ data }) => {
  const [hash, setHash] = useState('');

  useEffect(() => {
    setHash(window.location.hash);
  }, []);

  const homeProps = toHomeProps(data.data);

  return <Home {...homeProps} hash={hash} />;
};

export default PageHome;
